import { useTranslation } from "react-i18next";

/**
 * Loading bubble shown while a Blockbrain query is in flight (~20 s typical).
 * Mirrors the visual style of an assistant message but with three pulsing dots
 * and a "Frage Blockbrain..." caption so the user knows we are still working.
 */
export default function BlockbrainLoadingBubble() {
  const { t } = useTranslation();

  return (
    <div>
      <div
        className="max-w-3/4 flex flex-col rounded-lg p-4 shadow"
        style={{
          backgroundColor: "var(--bot-msg-bg)",
          color: "var(--bot-msg-text)",
        }}
      >
        <div className="flex items-center gap-3">
          <div className="flex gap-1">
            <span
              className="h-2 w-2 rounded-full bg-current opacity-70"
              style={{ animation: "blockbrainDot 1.2s ease-in-out infinite", animationDelay: "0s" }}
            />
            <span
              className="h-2 w-2 rounded-full bg-current opacity-70"
              style={{ animation: "blockbrainDot 1.2s ease-in-out infinite", animationDelay: "0.15s" }}
            />
            <span
              className="h-2 w-2 rounded-full bg-current opacity-70"
              style={{ animation: "blockbrainDot 1.2s ease-in-out infinite", animationDelay: "0.3s" }}
            />
          </div>
          <p className="text-sm italic">{t("avatarStatus.frage blockbrain")}</p>
        </div>
      </div>
      <style>{`
        @keyframes blockbrainDot {
          0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
          40% { transform: translateY(-3px); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
